<template>
  <div class="p-6">
    <h2 class="text-xl font-semibold mb-4">Company Map 설정</h2>

    <!-- 업로드 폼 -->
    <form @submit.prevent="uploadImage" class="mb-6 flex gap-4 items-center">
      <input type="file" ref="fileInput" accept="image/*" />
      <input type="text" v-model="description" placeholder="설명 (예: 1층 도면)" class="border p-2" />
      <button class="bg-blue-500 text-white px-4 py-2 rounded">업로드</button>
    </form>

    <!-- 썸네일 목록 (Finder 스타일) -->
    <div class="grid grid-cols-5 gap-1 mt-4">
      <div
        v-for="bg in backgrounds"
        :key="bg.id"
        class="border rounded shadow-sm p-0 w-[40px] h-[52px] text-center cursor-pointer hover:shadow-md flex flex-col items-center justify-between bg-white overflow-hidden"
        @click="goToZoneEditor(bg)"
      >
        <img
          :src="`/uploads/${encodeURIComponent(bg.saved_filename)}`"
          class="!w-[40px] !h-[40px] object-contain mx-auto border"
          :alt="bg.original_filename"
        />
        <p class="text-[10px] truncate w-full leading-none mt-0.5" :title="bg.original_filename">
          {{ bg.original_filename }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';

const company = 'SDAA';
const router = useRouter();
const fileInput = ref();
const description = ref('');
const backgrounds = ref([]);

async function uploadImage() {
  const file = fileInput.value.files[0];
  if (!file) return alert('파일을 선택하세요');

  const formData = new FormData();
  formData.append('image', file);
  formData.append('company', company);
  formData.append('description', description.value);

  try {
    await axios.post('/api/upload-background', formData);
    alert('업로드 성공');
    description.value = '';
    fileInput.value.value = '';
    await loadBackgrounds();
  } catch (err) {
    alert(err.response?.data?.message || '업로드 실패');
  }
}

async function loadBackgrounds() {
  backgrounds.value = (await axios.get(`/api/backgrounds?company=${company}`)).data;
}

function goToZoneEditor(bg) {
  router.push({ name: 'ZoneEditor', params: { imageId: bg.id } });
}

onMounted(() => {
  loadBackgrounds();
});
</script>

<style scoped>
input[type="file"] {
  border: 1px solid #ccc;
  padding: 6px;
}
</style>
